export default "__VITE_ASSET__DFr39rsc__"